import React from 'react';
import { Box, IconButton, InputAdornment, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import { COLORS } from '@styles';

interface IProps {
  value: string;
  onChange: (value: string) => void;
}

const makeStyles = () => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',
    alignItems: 'flex-start',
  } as React.CSSProperties,
  label: {
    color: COLORS.NEUTRAL_LIGHT_0,
    fontFamily: 'Inter',
    fontSize: '0.875rem',
    fontWeight: 600,
  } as React.CSSProperties,
  input: {
    width: '33rem',
    maxWidth: '100%',
    '& .MuiOutlinedInput-root': {
      borderRadius: '0.5rem',
      backgroundColor: COLORS.NEUTRAL_WHITE,
    },
    '& .MuiInputBase-input': {
      color: COLORS.NEUTRAL_DARK_1,
    },
  },
  icon: {
    color: COLORS.NEUTRAL_DARK_1,
  },
});

export function EmailLookupInput({ value, onChange }: IProps) {
  const sx = makeStyles();
  return (
    <Box sx={sx.container}>
      <label htmlFor="lookup-email" style={sx.label}>
        Email address
      </label>
      <TextField
        id="lookup-email"
        placeholder="name@example.com"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        variant="outlined"
        sx={sx.input}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon fontSize="small" sx={sx.icon} />
            </InputAdornment>
          ),
          endAdornment: value && (
            <InputAdornment position="end">
              <IconButton aria-label="Clear" size="small" onClick={() => onChange('')}>
                <ClearIcon fontSize="small" sx={sx.icon} />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
    </Box>
  );
}
